import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FiSearch } from "react-icons/fi";
import Highlighter from "react-highlight-words";

import { ScreenContainer, Input, Table } from "components";

import { actionTasksGetAll, selectAllTasks } from "pages/tasks/redux";

const TasksList = () => {
  const oDispatch = useDispatch();
  const aTasks = useSelector(selectAllTasks);
  const [sFilter, setFilter] = useState("");
  const [aFilteredTasks, setFilteredTasks] = useState([]);

  useEffect(() => {
    oDispatch(actionTasksGetAll());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setFilteredTasks(() => {
      return aTasks?.length
        ? aTasks
          .filter(
            oTask =>
              oTask.name?.toLowerCase().includes(sFilter.toLowerCase()) ||
              oTask.id?.toString().toLowerCase().includes(sFilter.toLowerCase()),
          )
          .map(oTask => ({ ...oTask, sFilter }))
        : [];
    });
  }, [aTasks, sFilter]);

  return (
    <ScreenContainer>
      <section className="grid grid-cols-2">
        <h1 className="ui-page-title self-center">
          Listado de tareas
        </h1>
      </section>
      <section className="grid grid-cols-4 mt-4">
        <div className="relative col-span-4 md:col-span-1">
          <div className="absolute inset-y-0 left-0 flex items-center pl-2.5 pointer-events-none">
            <FiSearch className="w-4 h-4 text-gray-400" />
          </div>
          <Input
            withoutClass
            value={sFilter}
            floatLabel={false}
            onChange={setFilter}
            placeholder="Buscar"
            containerClassName="rounded-lg overflow-hidden"
            className="ui-field-icon w-full"
          />
        </div>
      </section>
      <section className="py-5">
        <Table data-testid={"tasksTable"}>
          <Table.Header>
            <Table.Row isHeaderOrFooter>
              <Table.Col scope="col" className="px-3 py-2 text-center">
                #
              </Table.Col>
              <Table.Col scope="col" className="px-3 py-2 text-center">
                Nombre
              </Table.Col>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {aFilteredTasks.length > 0 ? (
              aFilteredTasks.map((oTask, nIndex) => (
                <Table.Row key={`${oTask.id}_${nIndex}`}>
                  <Table.Col
                    scope="row"
                    className="text-xs md:text-sm px-3 py-2 font-medium text-gray-800 dark:text-white whitespace-nowrap text-center"
                  >
                    {oTask.id}
                  </Table.Col>
                  <Table.Col className="px-3 py-2 text-center">
                    <Highlighter
                      searchWords={[oTask.sFilter]}
                      autoEscape={true}
                      textToHighlight={oTask.name}
                    />
                  </Table.Col>
                </Table.Row>
              ))
            ) : (
              <Table.Row>
                <Table.Col className="px-3 py-2 text-center" colSpan={3}>
                  <em>
                    {sFilter.length > 0
                      ? "No se encontraron resultados"
                      : "Sin tareas registradas"}
                  </em>
                </Table.Col>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </section>
    </ScreenContainer>
  );
};

export default TasksList;
